var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hero-banner"},[_c('div',{staticClass:"hero-banner-container"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12 col-md-6"},[_c('div',{staticClass:"hero-banner-title"},[_c('h1',[_vm._v(_vm._s(_vm.title))])])])])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }